"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var confirmDirtyOptionsAndPerformAction_1 = require("./confirmDirtyOptionsAndPerformAction");
exports.default = satcheljs_1.orchestratorAction('selectCategory', function selectCategory(category) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.selectCategory(category);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/selectCategory.js
// module id = 5282
// module chunks = 2